import { combineReducers } from "@reduxjs/toolkit";
import questionStore from './modules/questionStore';
import userStore from './modules/userStore';

export default combineReducers({
  questionStore,
  userStore, 
})
